<template>
    <b-modal size="md" hide-footer v-model="show" title="Edição da Configuração do Sistema" @hidden="cancelar">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <div><span class="font-weight-bold">Configuração:</span> {{ this.configuracao.tituloPropriedade }}
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-form @submit.prevent="salvar">
            <b-form-group style="padding-left: 15px">
                <b-form-checkbox v-model="form.autenticacao" @change="onAutenticacaoChange">
                    Autenticação
                </b-form-checkbox>
            </b-form-group>
            <b-form-group>
                <lg-form-input v-model="form.enderecoServidor" label="Endereço Servidor:" required />
            </b-form-group>
            <b-form-group>
                <lg-form-input v-model="form.portaServidor" label="Porta Servidor:" required type="number" />
            </b-form-group>
            <b-form-group v-if="form.autenticacao">
                <lg-form-input v-model="form.senha" label="Senha:" type="password" required />
            </b-form-group>
            <b-form-group>
                <lg-form-input v-model="form.remetenteEmail" label="Remetente (E-mail):" type="email" required />
            </b-form-group>
            <b-form-group>
                <lg-form-input v-model="form.remetenteRotulo" label="Remetente Rótulo:" required />
            </b-form-group>
            <b-form-group>
                <lg-form-input v-model="form.tamanhoMaxAnexo" label="Tamanho Máx. Anexo (MB):" type="number" required />
            </b-form-group>
            <b-form-group class="text-center">
                <b-button variant="primary" @click="abrirTesteEmail" size="sm">Testar</b-button>
            </b-form-group>
            <b-row v-if="mostrarTesteEmail">
                <lg-form-input v-model="testeEmail.destinatario" label="Destinatário:" type="email" sm="8" lg="8" />
                <b-button style="height: 28px;" class="mt-3" variant="success" size="sm"
                    @click="enviarTesteEmail">Enviar</b-button>
            </b-row>
            <b-form-row class="d-flex justify-content-center">
                <b-button type="submit" size="sm" pill variant="success">
                    <b-icon icon="check-circle" />
                </b-button>
                <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
                    <b-icon icon="x-circle" />
                </b-button>
            </b-form-row>
        </b-form>
    </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import lgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
    components: {
        lgFormInput,
    },
    props: {
        configuracao: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            show: true,
            form: {
                enderecoServidor: "",
                portaServidor: "",
                autenticacao: false,
                senha: "",
                remetenteEmail: "",
                remetenteRotulo: "",
                tamanhoMaxAnexo: "",
            },
            mostrarTesteEmail: false,
            testeEmail: {
                destinatario: "",
            },
        };
    },
    methods: {
        onAutenticacaoChange() {
            if (!this.form.autenticacao) {
                this.form.senha = "";
            }
        },
        abrirTesteEmail() {
            this.mostrarTesteEmail = !this.mostrarTesteEmail;
        },
        async enviarTesteEmail() {
            if (!this.testeEmail.destinatario) {
                this.$bvToast.toast("Informe o destinatário para o teste", {
                    title: "Erro",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            try {
                await ConfiguracaoSistemaService.enviarTesteEmail({
                    ...this.form,
                    destinatario: this.testeEmail.destinatario,
                });
                Swal.fire({
                    title: "Sucesso",
                    text: "E-mail de teste enviado com sucesso!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } catch (error) {
                this.$bvToast.toast("Erro ao enviar e-mail de teste", {
                    title: "Erro",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        async salvar() {
            if (
                !this.form.enderecoServidor ||
                !this.form.portaServidor ||
                !this.form.remetenteEmail ||
                !this.form.remetenteRotulo ||
                !this.form.tamanhoMaxAnexo ||
                (this.form.autenticacao && (!this.form.senha))
            ) {
                this.$bvToast.toast("Preencha todos os campos obrigatórios", {
                    title: "Erro",
                    variant: "danger",
                    solid: true,
                });
                return;
            }


            const valorPropriedade = [
                this.form.enderecoServidor,
                this.form.portaServidor,
                this.form.remetenteEmail,
                this.form.remetenteEmail,
                this.form.autenticacao ? this.form.senha : "null",
                this.form.remetenteRotulo,
                this.form.tamanhoMaxAnexo,
                this.form.autenticacao ? 1 : 0,
            ].join(";");

            const payload = {
                id: this.configuracao.id,
                valorPropriedade,
            };


            try {
                await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
                this.$emit("salvo");
                await Swal.fire({
                    title: "Sucesso",
                    text: "Configuração salva com sucesso!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } catch (error) {
                this.$bvToast.toast("Erro ao salvar configuração", {
                    title: "Erro",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        cancelar() {
            this.$emit("close");
        },
        carregarDadosIniciais() {
            if (this.configuracao.valorPropriedade && this.configuracao.valorPropriedade != "") {
                const valores = this.configuracao.valorPropriedade.split(";");
                this.form.enderecoServidor = valores[0] || "";
                this.form.portaServidor = valores[1] || "";
                this.form.remetenteEmail = valores[3] || "";
                this.form.senha = valores[4] !== "null" ? valores[4] : "";
                this.form.remetenteRotulo = valores[5] || "";
                this.form.tamanhoMaxAnexo = valores[6] || "";
                this.form.autenticacao = valores[7] == 1 ? true : false;
            }
        },
    },
    mounted() {
        this.carregarDadosIniciais();
    },
};
</script>

<style scoped>
.font-weight-bold {
    font-weight: bold;
}
</style>
